export default __webpack_public_path__ + "static/media/processing.da447162.svg";